export default (eventName, eventArgs) => {
	const event = new CustomEvent(eventName, eventArgs);
	window.dispatchEvent(event);
};
